module.exports = __webpack_public_path__ + "static/img/6.78b8cce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/eng/6.png
// module id = zz+F
// module chunks = 0